// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b3e47351","239":"0600be30","732":"b494fcc1"}[chunkId] + ".chunk.js";
};